// Basic Info
export const SCHOOL_NAME = "schoolName";
export const STATE = "state";
export const CITY = "city";
export const ZIP = "zip";
export const REGION = "geoRegionId";
export const PHONE = "phoneNumber";
export const EMAIL = "emailId";
export const WEBSITE = "website";
export const SCHOOL_LOGO = "logo";
export const ADDRESS1 = "address1";
export const ADDRESS2 = "address2";

//Academic and operational info
export const YEARS_OF_COLLABORATION = "academicCollaboration";
export const GRADES_SELECTED = "gradesSelected";
export const FACULTY_DAYS = "facultyDays";
export const NO_FACULTY_DAYS = "noOfFacultyDays";
export const EDUCATOR_TYPE = "educatorType";
export const MAINTENANCE = "maintenance";
export const SKU = "sku";
export const NO_OF_WORKSTATIONS = "noOfWorkStations";
export const INCLUDES_BOOKS = "includesBooks";
export const SCHOOL_TIER = "schoolTier";
export const SYLLABUS = "syllabus";
export const ACCOUNT_TYPE= "accountType";
export const STUDENT_STRENGTH= "studentStrength"

export const educatorOptions = [
  { label: "Educator (Half-Time)", value: "Educator (Half-Time)" },
  { label: "Educator (Full-Time)", value: "Educator (Full-Time)" },
  { label: "Non-Educator", value: "Non-Educator" },
];

export const maintenanceOptions = [
  { label: "Included", value: "Included" },
  { label: "Not Included", value: "Not Included" },
];

export const booksIncludeoptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const skuOptions = [
  { label: "Plus", value: "Premium" },
  { label: "Standard", value: "Standard" },
  { label: "Ignite", value: "Ignite" },
];

export const tierOptions = [
  { label: "Tier 1", value: "Tier1" },
  { label: "Tier 2", value: "Tier2" },
  { label: "Tier 3", value: "Tier3" },
];

export const syllabusOptions = [
  { label: "CBSE", value: "CBSE" },
  { label: "Cambridge", value: "Cambridge" },
  { label: "IB", value: "IB" },
  { label: "State Board", value: "State Board" },
];


export const accounttypeoptions = [
  { label: "Package A", value: "Class A" },
  { label: "Package B", value: "Class B" },
  { label: "Package C", value: "Class C" },
  { label: "Package D", value: "Class D" },
];